<template>
  <div>
    <div class="com-banner" style="background-image:url(https://fs.58keeper.com/join-bg.jpg)">
      <div class="banner-inner center">
        <h1>加入我们</h1>
        <p>让有大局观的同事走在队伍前面，共同创业</p>
      </div>
    </div>
    <div class="section">
      <div class="com-container">
        <div class="t-center">
          <h2>做更好的自己</h2>
          <p>我们坚持“做更好的自己”，热爱自由，希望自我驱动。</p>
          <p>我们年轻，心怀远大，满腹激情与活力。我们酷爱一切精致，愿为美好而喝彩。</p>
          <p>勇于探索和创新，致力构建分享经济。</p>
        </div>
      </div>
    </div>
    <div class="search-bg">
      <div class="search-box2">
        <div class="input">
          <input type="text" disabled placeholder="请输入你感兴趣的职位">
        </div>
        <div class="searchIcon search-zpbtn"></div>
      </div>
    </div>
    <div class="section job-section">
      <div class="com-container">
        <div style="padding-bottom: 20px;">
          <h2>加入多妙</h2>
          <p><a href="mailto:shiguodong@58keeper.com">简历投递邮箱：shiguodong@58keeper.com</a></p>
          <p>投递邮件主题注明：投递岗位+姓名。</p>
          <p style="color: red;">本招聘长期有效！</p>
        </div>
        <div class="job-condition">
          <div class="condition-item clearfix">
            <div class="condition-icon">
              <i class="iconfont icon0">&#xe637;</i>工作性质：
            </div>
            <div class="condition-txt">
              <span>全职</span>
              <span>实习</span>
            </div>
          </div>
          <div class="condition-item clearfix">
            <div class="condition-icon">
              <i class="iconfont">&#xe613;</i>职位类别：
            </div>
            <div class="condition-txt">
              <span>ota运营</span>
              <span>市场经理</span>
              <span>客服</span>
              <span>二手房经纪人</span>
            </div>
          </div>
        </div>
        <div class="job-table">
          <div class="job-tr job-header">
            <div class="list-4">职位名称</div>
            <div class="list-4">工作地点</div>
            <div class="list-4">招聘人数</div>
            <div class="list-4">发布时间</div>
          </div>
          <ul class="jon-list">
            <li class="job-list-item active">
              <div class="job-tr job-content">
                <div class="list-4">ota运营</div>
                <div class="list-4">海口</div>
                <div class="list-4">数名</div>
                <div class="list-4">2020-03-30</div>
              </div>
              <div class="job-txt">
                <p>工作职责</p>
                <p>1、负责站内推广，使用OTA平台进行房屋推广，提高出租订单；</p>
                <p>2、定期对店铺数据进行分析，及时调整推广方案；</p>
                <p>3、营销活动策划，全程实施并追踪效果；</p>
                <p>4、根据公司产品特色进行促销活动，进行有针对性的营销推广工作；</p>
                <p>5、关注平台内各项官方、非官方发起的营销活动的更新和变化，及时跟进各项活动，提升门店流量。</p>
                <br>
                <br>
                <p>加入我们</p>
                <p>1、餐补+交通补助+全勤奖等；</p>
                <p>2、五险；</p>
                <p>3、各类丰富节日礼品及惊喜；</p>
                <p>4、倡导快乐文化，丰富的公司及部门活动，各类俱乐部，茶话会等；</p>
                <p>5、Open 的工作氛围，自我驱动的工作模式；一群有伟大梦想的合作伙伴，如同家人般互助互爱；</p>
              </div>
            </li>
            <li class="job-list-item active">
              <div class="job-tr job-content">
                <div class="list-4">市场经理</div>
                <div class="list-4">海南各区</div>
                <div class="list-4">数名</div>
                <div class="list-4">2020-03-30</div>
              </div>
              <div class="job-txt">
                <p>工作职责</p>
                <p>1、负责推广公司业务；</p>
                <p>2、负责门店、保洁人员的管理；</p>
                <p>3、负责与房东签约，解决房东的问题，解决房屋内存在的问题；</p>
                <p>3、协调物业等本地各方面，解决合作矛盾等问题；</p>
                <br>
                <br>
                <p>加入我们</p>
                <p>1、餐补+交通补助+全勤奖等；</p>
                <p>2、五险；</p>
                <p>3、各类丰富节日礼品及惊喜；</p>
                <p>4、倡导快乐文化，丰富的公司及部门活动，各类俱乐部，茶话会等；</p>
                <p>5、Open 的工作氛围，自我驱动的工作模式；一群有伟大梦想的合作伙伴，如同家人般互助互爱；</p>
              </div>
            </li>
            <li class="job-list-item active">
              <div class="job-tr job-content">
                <div class="list-4">客服调度</div>
                <div class="list-4">海口</div>
                <div class="list-4">数名</div>
                <div class="list-4">2020-03-30</div>
              </div>
              <div class="job-txt">
                <p>工作职责</p>
                <p>1、负责电话推广公司业务；</p>
                <p>2、负责客户线索的收集；</p>
                <p>3、负责解决租客、房东的问题反馈，并按照实际情况自行解决或者将问题反馈给一线工作人员；</p>
                <p>3、负责系统信息的维护；</p>
                <br>
                <br>
                <p>加入我们</p>
                <p>1、餐补+交通补助+全勤奖等；</p>
                <p>2、五险；</p>
                <p>3、各类丰富节日礼品及惊喜；</p>
                <p>4、倡导快乐文化，丰富的公司及部门活动，各类俱乐部，茶话会等；</p>
                <p>5、Open 的工作氛围，自我驱动的工作模式；一群有伟大梦想的合作伙伴，如同家人般互助互爱；</p>
              </div>
            </li>
            <li class="job-list-item active">
              <div class="job-tr job-content">
                <div class="list-4">二手房经纪人</div>
                <div class="list-4">海南各区</div>
                <div class="list-4">1</div>
                <div class="list-4">2020-03-30</div>
              </div>
              <div class="job-txt">
                <p>工作职责</p>
                <p>1、负责推广公司业务；</p>
                <p>2、负责与房东沟通售房事宜，收集房东的各方面要求；</p>
                <p>3、负责与房产中介合作，包括不限于客源、房源相关线索的收集；</p>
                <p>3、负责完成买卖二手房全过程的各项事宜；</p>
                <br>
                <br>
                <p>加入我们</p>
                <p>1、餐补+交通补助+全勤奖等；</p>
                <p>2、五险；</p>
                <p>3、各类丰富节日礼品及惊喜；</p>
                <p>4、倡导快乐文化，丰富的公司及部门活动，各类俱乐部，茶话会等；</p>
                <p>5、Open 的工作氛围，自我驱动的工作模式；一群有伟大梦想的合作伙伴，如同家人般互助互爱；</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'contact',
  data: function () {
    return {}
  },
  methods: {
  },
  mounted () {
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Joinus.vue